<template>
  <b-row>
    <b-col
      cols="12"
      lg="6"
      offset-lg="3"
    >
      <div
        v-for="item in items"
        :key="item.id"
      >
        <app-collapse accordion>
          <app-collapse-item :title="item.question">
            {{ item.answer }}
          </app-collapse-item>
        </app-collapse>
        <br>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { ListTable } from '../../../common/mixins/list'

export default {
  name: 'FaqsCollapse',
  components: {
    AppCollapse,
    AppCollapseItem,
  },
  mixins: [ListTable],
}
</script>

<style lang="scss">
@import "~@core/scss/vue/pages/page-faq.scss";
</style>
